import { render } from "./Impuesto.vue?vue&type=template&id=d0981e6c&scoped=true"
import script from "./Impuesto.vue?vue&type=script&lang=js"
export * from "./Impuesto.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=d0981e6c&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0981e6c"]])

export default __exports__